import baseService from './baseService';

export const unsubscribeReferralRoundup = (token) => baseService.get(`/unsubscribe/${token}`);
